import {API, Cache} from '@/plugins/finAmplifyModules'

const MINUTE = 1000 * 60
const HOUR = MINUTE * 60
const DAY = HOUR * 24

const config = {
  keyPrefix: 'fin_datafetcher',
  storage: window.sessionStorage,
  defaultTTL: MINUTE * 10
}
const cacheInstance = Cache.createInstance(config)


const solver = {
  async fetchData(val, params, init) {
    if (typeof val === 'object') {
      const {query = null, variables = {}} = val
      const hasValidQuery = query && API.getGraphqlOperationType(query) === 'query'
      if (hasValidQuery) {
        const response = await API.graphql({query, variables})
        val = response.data
        val = await this.fetchData(val, params, init)
      }
      if (val?.load) {
        const {adapt, load, key, cacheInitOnly} = val
        const keyVal = key ? await this.fetchData(key, params) : null
        const cachedValue = keyVal ? cacheInstance.getItem(keyVal) : null
        if (!cachedValue || cacheInitOnly) {
          if (init) {
            if (cachedValue) {
              const initval = await adapt(cachedValue, true)
              await init(initval)
            } else if (val.init) {
              const initval = await this.fetchData(val.init, params)
              await init(initval)
            }
          }

          val = await this.fetchData(load, params, init)

          if (keyVal) {
            //TODO custom cache options
            //longer caching for init values
            cacheInstance.setItem(keyVal, val, cacheInitOnly ? {expires: new Date().getTime() + (HOUR * 24)} : null)
          }
        } else {
          val = cachedValue
        }

        if (adapt) {
          //dont cache adapted version it can contains already functions
          val = await adapt(val)
        }

      }
    } else if (typeof val === 'function') {
      val = await val(params)
      val = await this.fetchData(val, params, init)
    }

    return val
  }
}


export default {
  async fetchData(resolver, params, dataAdapter, init) {
    let val = await solver.fetchData(resolver, params, async (val) => {
      if (init) {
        await init(val)
      }
    })

    if (dataAdapter) {
      val = await dataAdapter(val, params)
    }

    return val
  }
}
